(function() {
    'use strict';

    angular
        .module('cfiApp')
        .controller('CFICancelReasonDialogController', CFICancelReasonDialogController);

    CFICancelReasonDialogController.$inject = ['$scope', '$uibModalInstance', 'cfiInfo', 'CFIService'];

    function CFICancelReasonDialogController ($scope, $uibModalInstance, cfiInfo, CFIService) {
    	var cancelReasonDlgCtr = this;
    	cancelReasonDlgCtr.cancel= cancel;
    	cancelReasonDlgCtr.cancelReasonCFI = cancelReasonCFI;
    	cancelReasonDlgCtr.errorMessage = null;
    	cancelReasonDlgCtr.cancelReasons = [];
    	CFIService.query({uri:'retention-cancel-reason'}, function(data){
			cancelReasonDlgCtr.cancelReasons = data;
		},function(error){
		});
    	  function cancelReasonCFI() {
    		  cfiInfo.cancelReasonTxn = cancelReasonDlgCtr.reason.retentionCancelId;
    		  cfiInfo.cancelReasonTxnName = cancelReasonDlgCtr.reason.retentionCancelDes;
    		  cfiInfo.transaction.reasonCancel = cancelReasonDlgCtr.reason.retentionCancelId + ' - ' + cancelReasonDlgCtr.reason.retentionCancelDes;
    		  CFIService.post({uri:'do-cancel-txn-cfi'},cfiInfo, 
    		 function (result){
    			 $uibModalInstance.close(result);
    		 }, function (error){
    			if(error.data.errorDTO != null){
    				 cancelReasonDlgCtr.errorMessage = error.data.errorDTO.message;
         		}
    		 });  
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    }
})();
